export default interface ProblemDetail {
  type: string;
  title: string;
  detail: string;
  status: number;
}

export function isProblemDetail(obj: unknown): obj is ProblemDetail {
  return (obj as ProblemDetail)?.type !== undefined;
}
